import View from "../common/views/CountdownView";
import components from "./components.js";
components.define("js-bf-countdown", View);